import variables from "theme/variables";
import { ComponentProps, FunctionComponent } from "react";
import _Select from "react-select";

type OwnProps = {
  value: any;
  setFieldValue?: (name: string, value: string) => any;
};
type Props = OwnProps & Omit<ComponentProps<typeof _Select>, "value">;

export const customSelectStyles = {
  option: (provided, state) => {
    const style = {
      ...provided,
      padding: variables.SPACING,
    };

    if (state.isFocused) {
      style.background = "#0c151f";
    } else {
      style.background = "#06090e";
    }

    return style;
  },
  control: (provided, state) => ({
    ...provided,
    background: "#06090e",
    border: "none",
    padding: 8,
    minWidth: "200px",
    maxWidth: "600px",
    margin: "auto",
  }),
  singleValue: (provided, state) => {
    return { ...provided, color: "white" };
  },
  menu: (provided, state) => ({ ...provided, background: "#06090e" }),
  multiValue: (provided) => ({ ...provided, background: "#0b141d" }),
  multiValueLabel: (provided) => ({ ...provided, color: "white" }),
};

const Select: FunctionComponent<Props> = (props) => {
  const onChange = (value) =>
    props.setFieldValue ? props.setFieldValue(props.name, value.value) : props.onChange(value);

  const value = Array.isArray(props.value) ? props.value : props.options.find((option) => option.value === props.value);

  return <_Select styles={customSelectStyles} {...props} value={value} onChange={onChange} />;
};

export default Select;
